import React from 'react';
import { useUp, vui } from '../core';
import { Heading } from '../heading';
import { cs } from '../utils';
/** Logo displayed in the left corner of the Header. */
export const HeaderApplicationName = vui((props, ref) => {
    const { title, ...rest } = props;
    const isTablet = useUp('md');
    const additionalClassName = isTablet ? 'vui-headerApplicationNameTablet' : 'vui-headerApplicationNameMobile';
    const mobileProps = isTablet
        ? {
            fontSize: 18,
            mt: 0
        }
        : {
            fontSize: 16,
            mt: '112px',
            position: 'absolute',
            mx: '-16px',
            w: '100%',
            bg: 'skyBlue.97',
            py: '8px',
            px: '16px',
            lineHeight: '24px',
            borderBottom: '1px solid darkBlue.main',
            borderTop: '1px solid darkBlue.main'
        };
    return (React.createElement(Heading, { className: cs('vui-headerApplicationName', additionalClassName), size: "title", ...rest, ...mobileProps }, title));
});
export default HeaderApplicationName;
